// extracted by mini-css-extract-plugin
export default {"form":"SendSmsModal_form__I7SN4","errorBanner":"SendSmsModal_errorBanner__GV1MU"};